/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Faq_4_QInputs */

const en_pc_faq_4_q = /** @type {(inputs: Pc_Faq_4_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can PhotoCraft open Photoshop PSD files?`)
};

const zh_pc_faq_4_q = /** @type {(inputs: Pc_Faq_4_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PhotoCraft 能打开 Photoshop 的 PSD 文件吗？`)
};

/**
* | output |
* | --- |
* | "Can PhotoCraft open Photoshop PSD files?" |
*
* @param {Pc_Faq_4_QInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_faq_4_q = /** @type {((inputs?: Pc_Faq_4_QInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Faq_4_QInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_faq_4_q(inputs)
	return zh_pc_faq_4_q(inputs)
});
export { pc_faq_4_q as "pc.faq.4.q" }